import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import 'jquery';
import 'notify';
import { SecurityService } from '../../services/security-service';

@autoinject
export class AddRemoveCarrierDivisionDialog {
    constructor(
        protected controller: DialogController,
        private securityService: SecurityService,
        private busyService: BusyService,
        private api: WebApiService) {
    }


    title: string;
    model: any;
    mills: Array<any> = [];
    public divisionId: number = undefined;
    public divisionLabel: string = "";

    public save() {
        if (!this.divisionId) {
            alert("Please select a division");
            return;
        }
        this.controller.ok(this.divisionId);
    }

    async activate(model) {
        this.model = model;

        this.title = (model.add ? "Add" : "Remove") + " this carrier for your division roster?";
        //this.message = "Select the division and click Save to " + (add ? "add" : "remove") + " this carrier to the division roster",

        const verb = this.model.add ? "add" : "remov";
        this.divisionLabel = "Select the division for which the carrier should be " + verb + "ed:";

        await this.loadMills();
    }

    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                let mills = JSON.parse(result.response);
                const userDivisions = this.securityService.user.millCodes;
                const carrierDivisions = this.model.carrierDivisions;

                if (userDivisions.length > 0) {
                    mills = mills.filter(o => userDivisions.indexOf(o.millId) > -1);
                }

                // if removing, the only show mills that the carrier is already assigned to.
                if (!this.model.add) {
                    mills = mills.filter(o => carrierDivisions.indexOf(o.id) > -1);
                }
                // if adding, then only show mills that the carrier is not assigned to
                if (this.model.add) {
                    mills = mills.filter(o => carrierDivisions.indexOf(o.id) == -1);
                }

                this.mills = mills;
            })
            .finally(() => {
                this.busyService.off();
            });
    }

}
